(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["edc-week-entry"] && !Shopify.designMode) return;
  try {
    
function initEdcEntry(root) {
 if (root.dataset.edcReady) return;
 root.dataset.edcReady = 'true';
 const form = root.querySelector('[data-edc-preview-form]');
 if (!form) return;
 const messages = JSON.parse(root.querySelector('[data-edc-messages]').textContent);
 const post = form.elements.post_link;
 const dialog = root.querySelector('dialog');
 const validPost = value => { if (!value.trim()) return true; try { const u = new URL(value.trim()); return u.protocol === 'https:' && ['instagram.com','www.instagram.com'].includes(u.hostname) && /^[/](p|reel)[/][A-Za-z0-9_-]+[/]?$/.test(u.pathname); } catch { return false; } };
 const update = () => { const valid = validPost(post.value); post.setCustomValidity(valid ? '' : messages.invalid); const extra = !!post.value.trim() && valid; root.querySelector('[data-edc-weight]').textContent = extra ? '3' : '1'; root.querySelector('[data-edc-weight-label]').textContent = extra ? messages.three : messages.one; };
 post.addEventListener('input',update);
 form.addEventListener('submit',event => { event.preventDefault(); update(); if (!form.reportValidity()) return; dialog.showModal(); });
 root.querySelector('[data-edc-close]').addEventListener('click',() => dialog.close());
 dialog.addEventListener('click',event => { if (event.target === dialog) { const bounds=dialog.getBoundingClientRect(); if(event.clientX<bounds.left||event.clientX>bounds.right||event.clientY<bounds.top||event.clientY>bounds.bottom) dialog.close(); } });
}
document.querySelectorAll('[data-edc-form-root]').forEach(initEdcEntry);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-edc-form-root]').forEach(initEdcEntry));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hokolite-youtube-gallery"] && !Shopify.designMode) return;
  try {
    
  const initializeHokoliteYouTube = (root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    root.querySelectorAll('[data-youtube-poster-placeholder]').forEach((placeholder) => {
      const player = placeholder.closest('[data-youtube-player]');
      const videoId = player?.dataset.videoId;
      if (!videoId) return;

      const poster = document.createElement('img');
      poster.className = 'hokolite-youtube__poster';
      poster.src = `https://i.ytimg.com/vi/${encodeURIComponent(videoId)}/maxresdefault.jpg`;
      poster.dataset.youtubePoster = '';
      poster.dataset.fallbackSrc = `https://i.ytimg.com/vi/${encodeURIComponent(videoId)}/hqdefault.jpg`;
      poster.alt = player.dataset.videoTitle || '';
      poster.width = 1280;
      poster.height = 720;
      poster.loading = 'lazy';
      placeholder.replaceWith(poster);
    });

    root.querySelectorAll('[data-youtube-poster]').forEach((poster) => {
      poster.addEventListener('error', () => {
        if (poster.dataset.fallbackSrc && poster.src !== poster.dataset.fallbackSrc) {
          poster.src = poster.dataset.fallbackSrc;
        }
      }, { once: true });
    });

    root.querySelectorAll('[data-youtube-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const player = trigger.closest('[data-youtube-player]');
        if (!player) return;

        const videoId = player.dataset.videoId;
        if (!videoId) return;

        const iframe = document.createElement('iframe');
        iframe.className = 'hokolite-youtube__iframe';
        iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?autoplay=1&rel=0`;
        iframe.title = player.dataset.videoTitle || '';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.allowFullscreen = true;
        player.replaceChildren(iframe);
      }, { once: true });
    });
  };

  const initializeAllHokoliteYouTube = (scope = document) => {
    scope.querySelectorAll('[data-hokolite-youtube]').forEach(initializeHokoliteYouTube);
  };

  initializeAllHokoliteYouTube();
  document.addEventListener('shopify:section:load', (event) => initializeAllHokoliteYouTube(event.target));

  } catch(e) { console.error(e); }
})();
})();
